// External Links
export const PHYNTEX_REGISTER = "https://gocxm.co/links/go/476696";
export const TELEGRAM_PM = "https://t.me/m/UZfp7iGJZWY1";
export const INSTAGRAM = "https://www.instagram.com/helloasyrol?igsh=MTBhNWx2dm9tYmxydg==";
export const TIKTOK = "https://www.tiktok.com/@helloasyroll?_r=1&_t=ZS-95Z7ZmewqY5";
export const CHANNEL_ASYROL = "https://t.me/+u70fgxl-QkViZDU1";

// Certificate Assets
export const CERTIFICATES = [
  {
    id: "ftmo",
    title: "FTMO Challenge Passed",
    subtitle: "Certified Funded Trader",
    image: "/assets/cert-ftmo.jpg",
    date: "20 Apr 2026"
  },
  {
    id: "phase1",
    title: "Phase 1 Evaluation",
    subtitle: "Prop Firm Achievement",
    image: "/assets/cert-phase1.png",
    date: "2 Jun 2026"
  },
  {
    id: "phase2",
    title: "Phase 2 Evaluation",
    subtitle: "Prop Firm Achievement",
    image: "/assets/cert-phase2.png",
    date: "11 Jun 2026"
  }
];

// Feedback Images
export const FEEDBACK_IMAGES = [
  "/assets/feedback1.jpg",
  "/assets/feedback2.jpg",
  "/assets/feedback3.jpg"
];
